// Google Analytics 4 Next.js Template without History Change Trigger
// https://www.learnbestcoding.com/post/50/google-analytics4-with-react-js-and-next-js

import { isDDEnv } from './helper';

// @TODO: remove hardcode when reza is back from PTO
export const GTM_ID =
  process.env.NEXT_PUBLIC_GTM_ID || isDDEnv() ? 'GTM-MDB9XCJ' : 'GTM-MQVLL8S';

export const analytics = ({ window, document, detail }) => {
  // @TODO: remove this after testing done
  if (!isDDEnv() && !process.env.NEXT_PUBLIC_ENABLE_ANALYTICS) return;

  window.dataLayer = window?.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  //  to flush default
  const DEFAULT_DETAIL = {
    animation: undefined,
    element_name: undefined,
    event: undefined,
    filter_action: undefined,
    filter_value: undefined,
    link_classes: undefined,
    link_text: undefined,
    link_url: undefined,
    link_domain: undefined,
    social_platform: undefined,
    channel: undefined,
    form_name: undefined,
    lead_type: undefined,
    lead_country: undefined,
    lead_role: undefined,
    lead_enquiry_type: undefined,
    search_term: undefined,
    slug: undefined,
    page_url: undefined,
  };

  const { event, ...eventParams } = detail;
  window.dataLayer.push(
    {
      event,
      eventParams: {
        // flush previous key
        // ...DEFAULT_DETAIL,
        ...eventParams,
        slug: window?.location?.hash,
        page_url: window?.location?.href,
      },
    },
    { eventParams: undefined }
  );
  // To avoid Multiple installations of google tag manager detected warning
  if (!scriptExists()) {
    const newScript = document.createElement('script');
    newScript.async = true;
    newScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}&l=dataLayer`;

    const [scriptEl] = document.getElementsByTagName('script');
    scriptEl?.parentNode?.insertBefore(newScript, scriptEl);
  }
};

const scriptExists = () => {
  const scripts = Array.from(document.getElementsByTagName('script'));
  const hasScript = (script) => {
    return script?.src?.includes(GTM_ID);
  };
  return scripts?.length > 0 ? scripts.some(hasScript) : false;
};

// START: generate detail for dataLayer.push
const getDomain = (url) => url && new URL(url)?.hostname;

export const getHeroCtaDetail = (e, { url }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Hero CTA',
  animation: 'Navigate to homepage story',
  link_url: window?.location?.origin + url,
});

export const getScrollToTopDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Floating return to top CTA',
  animation: 'Top of page',
});
export const getClickSocialDetail = (e, { url, platform }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_url: url,
  link_domain: getDomain(url),
  social_platform: platform,
});

export const getClickCtaDetail = (e, { localUrl, url, name } = {}) => {
  const link = localUrl ? `${window?.location?.origin + localUrl}` : url;
  return {
    event: 'click',
    link_classes: e?.target?.classList?.value,
    link_url: link,
    link_domain: getDomain(link),
    link_text: name ?? e?.target?.textContent,
    element_name: 'Navigation CTA',
  };
};

export const getClickExternalCtaDetail = (e, { url, name } = {}) => {
  return {
    event: 'click',
    link_classes: e?.target?.classList?.value,
    link_url: url,
    link_domain: getDomain(url),
    link_text: name ?? e?.target?.textContent,
  };
};

export const getClickCtaCutDetail = (
  e,
  { localUrl, url, elementName } = {}
) => {
  const link = localUrl ? `${window?.location?.origin + localUrl}` : url;
  return {
    event: 'click',
    link_classes: e?.target?.classList?.value,
    link_url: link,
    link_domain: getDomain(link),
    link_text: e?.target?.textContent,
    element_name: elementName,
  };
};

// dd cow parts anchor navigation
export const getCowNavigation = (e, { part }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Products jumplinks',
  link_text: part,
});

export const getClickFooterNavigation = (e, { url }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_url: window?.location?.origin + url,
  link_domain: window?.location?.origin,
  link_text: e?.target?.textContent,
  element_name: 'Footer navigation',
});

export const getClickHeaderNavigation = (e, { url }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_url: window?.location?.origin + url,
  link_domain: window?.location?.origin,
  link_text: e?.target?.textContent,
  element_name: 'Header navigation',
});

export const getFilterDropdownDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Filter icon',
  animation: 'Filter open',
});

export const getNavigationOpenDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Hamburger icon',
  animation: 'Menu open',
});

export const getSearchOpenDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Search',
  animation: 'Search open',
  element_location: undefined,
});

export const getSearchDetail = ({ searchTerm, searchResultCount }) => ({
  event: 'search',
  search_term: searchTerm,
  search_results: searchResultCount ?? 0,
});

export const getPaginationDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Pagination links',
  animation: 'New page',
  link_text: e.selected + 1,
});
export const getVisitWebsite = (e, { url }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_text: e?.target?.textContent,
  link_url: url,
  link_domain: getDomain(url),
});

export const getDirections = (e, { url }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_text: e?.target?.textContent,
  link_url: url,
  link_domain: getDomain(url),
});

export const getPrintDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_location: undefined,
  element_name: 'Print button',
});

export const getPageShareDetail = (e, { channel }) => ({
  event: 'click',
  link_classes: e?.target?.parentNode?.parentNode?.classList?.value,
  element_name: 'Share button',
  channel: channel,
});

export const getAnchorNavigationDetail = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Floating navigation',
  animation: 'Jump to section',
  link_text: e?.target?.textContent,
});

export const getCutDetail = (e, { cutPart }) => ({
  event: 'filter',
  link_classes: e?.classList?.value,
  element_name: 'Interactive cut filter',
  filter_action: 'add',
  filter_name: 'Cut',
  filter_value: cutPart,
});

// wh contact form submit
export const getContactSubmitDetail = (_e, { country, role }) => ({
  event: 'form_submit',
  form_name: 'Contact form',
  lead_type: 'Enquiry',
  lead_country: country,
  lead_role: role,
});

export const getContactSubmitSuccess = (_e, { country, role }) => ({
  event: 'generate_lead',
  form_name: 'Contact form',
  lead_type: 'Enquiry',
  lead_country: country,
  lead_role: role,
});

// dd contact form submit
export const getContactDDSubmitDetail = (_e) => ({
  event: 'form_submit',
  form_name: 'Send inquiry form',
});

export const getContactDDSubmitSuccess = (_e) => ({
  event: 'generate_lead',
  form_name: 'Send inquiry form',
});

export const getLeadGenSubmitDetail = (_e, { isPromotional }) => ({
  event: 'form_submit',
  form_name: isPromotional ? 'Promotional sign-up form' : 'Sign-up form',
});

export const getLeadGenSubmitSuccess = (_e, { isPromotional }) => ({
  event: 'generate_lead',
  form_name: isPromotional ? 'Promotional sign-up form' : 'Sign-up form',
});

export const getLeadGenSubmitDetailWH = (_e, forms) => ({
  event: 'form_submit',
  ...forms
});

export const getLeadGenSubmitSuccessWH = (_e, forms) => ({
  event: 'generate_lead',
  ...forms
});

export const getExploreMap = (_e, { linkText }) => ({
  event: 'click',
  animation: 'Launch map',
  link_text: linkText,
});

export const getExploreMapSidebarOpen = (_e, { linkText }) => ({
  event: 'click',
  animation: 'Open sidebar',
  link_text: linkText,
});

// click on explore sidebar
export const getExploreMapInteractionSidebar = (_e, { station }) => ({
  event: 'map_location',
  map_element: station,
  map_interaction: 'Side bar',
});

// click on map
export const getExploreMapInteractionMapPin = (_e, { station, category }) => ({
  event: station ? 'map_location' : 'map_category',
  map_element: station ?? category,
  map_interaction: 'Map pin',
});

// click on detail sidebar (footer links / station list)
export const getExploreMapInteractionDetailWindowNav = (
  _e,
  { station, category }
) => ({
  event: station ? 'map_location' : 'map_category',
  map_element: station ?? category,
  map_interaction: 'Detail window nav',
});

export const getFaqOpen = (e, { linkText, id }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  animation: 'Expand FAQ',
  element_name: 'FAQ',
  link_text: linkText,
  click_id: id,
});

export const getFilterApply = (e, filters = {}, { name } = {}) => ({
  event: 'filter',
  link_classes: e?.target?.classList?.value,
  element_name: name,
  filter_action: 'Add',
  ...filters,
});

// click prev next on carousel slider
export const getCarouselNext = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Image carousel links',
  animation: 'Next item',
});

export const getCarouselPrevious = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Image carousel links',
  animation: 'Previous item',
});

export const getCarouselDotNext = (e) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  element_name: 'Carousel navigation',
  animation: 'Next item',
});

// lang switcher
export const getLanguageSwitcher = (e, { url, name }) => ({
  event: 'click',
  link_classes: e?.target?.classList?.value,
  link_domain: url,
  link_text: name ?? e?.target?.textContent,
  link_url: url,
  element_name: 'Language selection',
});
